import gql from 'graphql-tag';

export const GET_COMPANION_PLAYER_LIST = gql`
    query (
        $reserve_no: String!
    ){
        GetCompanionPlayerList (
            reserve_no: $reserve_no
        ){
            CompanionLists{
                id
                friend_id
                reserve_no
                player_no
                member_no
                player_name
                mobile_number
                email
                friend_flag
                add_friend_flag
                valid_flag
                pts_reserve_no
                companion_id
                select_flag
            }
            selectNumber
            emailDisb
            mobileNumberDisb
        }
    }
`;

export const GET_COMPANION_PLAYER_LIST_FROM_COMPANION_REGIST = gql`
    query (
        $reserve_no: String!
    ){
        GetCompanionPlayerListFromCompanionRegist (
            reserve_no: $reserve_no
        ){
            CompanionLists{
                reserve_no
                player_no
                member_no
                player_name
                mobile_number
                email
                friend_flag
                valid_flag
                pts_reserve_no
                gender
                birth_date
                nickname
                era
                score_level
                profile
                enthusiasm
                member_class
                visited_code
                represent_flag
                org_gender
                org_nickname
                org_era
                org_score_level
                org_profile
                companion_id
            }
        }
    }
`;

export const REGIST_COMPANION_LIST = gql`
    mutation(
        $CompanionPlayerList: [CompanionPlayerList]
    ){
        RegistCompanionPlayerList(
            RegistCompanionLists: $CompanionPlayerList
        ){
            CompanionLists{
                id
                friend_id
                reserve_no
                player_no
                member_no
                player_name
                mobile_number
                email
                friend_flag
                add_friend_flag
                valid_flag
                pts_reserve_no
                companion_id
                select_flag
            }
            selectNumber
            result
        }
    }
`;

export const REGIST_COMPANION_LIST_PLAYER = gql`
    mutation(
        $reserve_no: String!
        $player_no: Int
        $player_name: String
        $mobile_number: String
        $email: String
    ){
        RegistCompanionListPlayer(
            reserve_no: $reserve_no
            player_no: $player_no
            player_name: $player_name
            mobile_number: $mobile_number
            email: $email
        ){
            CompanionLists{
                id
                friend_id
                reserve_no
                player_no
                member_no
                player_name
                mobile_number
                email
                friend_flag
                add_friend_flag
                valid_flag
                pts_reserve_no
                companion_id
                select_flag
            }
            selectNumber
        }
    }
`;

export const REGIST_FRIEND_COMPANION_LIST = gql`
    mutation(
        $represent_member_no: String
        $reserve_no: String
        $player_no: Int
        $member_no: String
        $player_name: String
        $family_name: String
        $given_name: String
        $mobile_number: String
        $email: String
    ){
        RegistFriendCompanionList(
            represent_member_no: $represent_member_no
            reserve_no: $reserve_no
            player_no: $player_no
            member_no: $member_no
            player_name: $player_name
            family_name: $family_name
            given_name: $given_name
            mobile_number: $mobile_number
            email: $email
        ){
            CompanionLists{
                id
                friend_id
                reserve_no
                player_no
                member_no
                player_name
                mobile_number
                email
                friend_flag
                add_friend_flag
                valid_flag
                pts_reserve_no
                companion_id
                select_flag
            }
            selectNumber
        }
    }
`;

export const DELETE_COMPANION_LIST_PLAYER = gql`
    mutation(
        $friend_id: Int,
        $reserve_no: String,
        $player_no: Int,
        $member_no: String,
        $player_name: String,
        $mobile_number: String,
        $email: String,
        $friend_flag: Int,
        $valid_flag: Int
    ){
        DeleteCompanionListPlayer(
            friend_id: $friend_id,
            reserve_no: $reserve_no,
            player_no: $player_no,
            member_no: $member_no,
            player_name: $player_name,
            mobile_number: $mobile_number,
            email: $email,
            friend_flag: $friend_flag,
            valid_flag: $valid_flag
        ){
            CompanionLists{
                id
                friend_id
                reserve_no
                player_no
                member_no
                player_name
                mobile_number
                email
                friend_flag
                add_friend_flag
                valid_flag
                pts_reserve_no
                companion_id
                select_flag
            }
            selectNumber
        }
    }
`;

export const REGIST_COMPANION_LIST_PLAYER_FRIEND = gql`
    mutation(
        $FriendPlayerList: [FriendPlayerList]
    ){
        RegistCompanionListPlayerFriend(
            FriendPlayerLists: $FriendPlayerList
        ){
            CompanionLists{
                id
                friend_id
                reserve_no
                player_no
                member_no
                player_name
                mobile_number
                email
                friend_flag
                add_friend_flag
                valid_flag
                pts_reserve_no
                companion_id
                select_flag
            }
            selectNumber
        }
    }
`;
